import { render } from "./opTime.vue?vue&type=template&id=592fb52a&ts=true"
import script from "./opTime.vue?vue&type=script&lang=ts"
export * from "./opTime.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__